import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { LanguageService, WindowRef } from '@spartacus/core';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { LanguageDateChangeRequest } from '../../../save-cart/store/state/cart-details.state';
import { LanguageSelectorTrackingService } from '../../services/language-selector-tracking.service';

@Component({
    selector: 'app-language-selector-header',
    templateUrl: './language-selector-header.component.html',
    styleUrl: './language-selector-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LanguageSelectorHeaderComponent {

  selected: string = '';
  public currentLanguage: string = 'ENG';
  myHeaderForm: FormGroup;
  public isLoggedIn: boolean = false;
  public previousLanguage: string = '';

  constructor(
    private languageService: LanguageService,
    private fb: FormBuilder,
    private globalService: GlobalService,
    private languageTrackingService: LanguageSelectorTrackingService,
    private windowRef: WindowRef
  ) { }

  ngOnInit() {
    this.globalService.loginBanner$.subscribe((data) => {
      this.isLoggedIn = data;
    })
    this.languageService.getActive().subscribe((lang) => {
      switch (lang) {
        case 'en':
          this.selected = 'ENG'
          break;
        case 'de':
          this.selected = 'GER'
          break;
        default:
          this.selected = 'ESP'
      }
      this.currentLanguage = lang;
      this.returnCurrentSelector(this.currentLanguage)
    });
    this.globalService.languageValue$.subscribe((x) => {
      if (x) {
        this.myHeaderForm.patchValue({
          language: x,
        });
      }
    })
    this.myHeaderInitialise();
  }

  returnCurrentSelector(value) {
    if (value === 'de') {
      return 'GER'
    }
    else if (value === 'es') {
      return 'ESP'
    }
    else {
      return 'ENG'
    }
  }

  selectLanguageCHandler(language: string, event?: Event): void {
    const clickTarget = event?.target as HTMLElement;
    // Track language switch analytics
    this.languageTrackingService.trackLanguageSwitch(
      this.currentLanguage,
      clickTarget
    );
    // Store the previous language before changing
    this.previousLanguage = this.currentLanguage;
    // Existing business logic
    this.languageService.setActive(language);
    if (!this.isLoggedIn) {
      let langDateObj = { languageISOCode: language }
      this.languageDateChange(langDateObj);
    }
    this.windowRef.nativeWindow.location.reload();
  }

  onDropdownToggle(event: Event): void {
    const clickTarget = event.target as HTMLElement;
    const dropdown = clickTarget.closest('.dropdown');
    const isOpen = dropdown?.classList.contains('show');

    if (!isOpen) {
      // Dropdown is being opened
      this.languageTrackingService.trackLanguageDropdownOpen(this.currentLanguage, clickTarget);
    } else {
      // Dropdown is being closed
      this.languageTrackingService.trackLanguageDropdownClose(this.currentLanguage);
    }
  }

  onLanguageHover(language: string, event: Event): void {
    const clickTarget = event.target as HTMLElement;
    this.languageTrackingService.trackLanguageHover(language, this.currentLanguage, clickTarget);
  }

  onDropdownClose(): void {
    this.languageTrackingService.trackLanguageDropdownClose(this.currentLanguage);
  }

  languageDateChange(langDateObj: LanguageDateChangeRequest){
    this.globalService.addLanguageDateChange(langDateObj).subscribe(()=>{
      // TO Apply currency and price formats to Table
      this.windowRef.nativeWindow.location.reload();
    })
  }

  myHeaderInitialise() {
    this.myHeaderForm = this.fb.group({
      language: [this.returnCurrentSelector(this.currentLanguage)],
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.myHeaderForm.controls;
  }

}
